import './Template.scoped.scss'

const getIcon = (iconType) => {
  switch (iconType) {
    case "petition":
      return <SvgIconsSignature width={48} height={48} />
    case "survey":
      return <SvgIconsCircleQuestion width={48} height={48} />
    case "signup":
      return <SvgIconsMembers width={48} height={48} />
    case "mail":
      return <SvgIconsMail width={48} height={48} />
    case "event":
      return <SvgIconsCalendar2 width={48} height={48} />
    case "donate":
      return <SvgIconsMoney width={48} height={48} />
    default:
      return <SvgIconsPages width={48} height={48} />
  }
  // TODO: generate these dynamically
}

const Template = ({ section, templates, setTemplate }) => {
  const enabledTemplates = templates.filter(t => t.enabledForNewPages)
  const standardTemplates = enabledTemplates.filter(t => t.systemTemplate).sort((a, b) => a.name.localeCompare(b.name))
  const customTemplates = enabledTemplates.filter(t => !t.systemTemplate).sort((a, b) => a.name.localeCompare(b.name))

  return (
    <>
      <div className="header margin-left">
        <h2 className="margin-bottom">Choose a template</h2>
      </div>
      
      {standardTemplates.length > 0 && (
        <>
          <h3 className="section-title margin-left">Standard templates</h3>
          <div className='template'>
            {standardTemplates.map(template => (
              <a className="card large selectable" onClick={() => setTemplate(template)} key={template.id}>
                {getIcon(template.icon)}
                <div className="template-content">
                  <h3>{template.name}</h3>
                  <p>{template.description}</p>
                </div>
              </a>
            ))}
          </div>
        </>
      )}

      {customTemplates.length > 0 && (
        <>
          <h3 className="section-title margin-left">Custom templates</h3>
          <div className='template'>
            {customTemplates.map(template => (
              <a className="card large selectable" onClick={() => setTemplate(template)} key={template.id}>
                {getIcon(template.icon)}
                <div className="template-content">
                  <h3>{template.name}</h3>
                  <p>{template.description}</p>
                </div>
              </a>
            ))}
          </div>
        </>
      )}

      {templates.length === 0 && <p className="small dark-grey margin-left no-margin-top">No {section === 'ballots' ? 'ballot' : 'page'} templates set up</p>}
    </>
  )
}

export default Template
